import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "repayment-term-selection"
}
const _hoisted_2 = {
  class: "buttons",
  id: "repayment-terms"
}
const _hoisted_3 = ["onClick"]

import { RateTypeIds } from "@/config/constants";
import type { RepaymentTermOption } from "@/models/loanConfiguration";
import { ref, computed } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentTermSelection',
  props: {
    selectedRateTypeId: {},
    selectedRateType: {}
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();

const props = __props;

const selectedRepaymentTermId = ref<number>(0);
const selectedRepaymentTermOption = ref<RepaymentTermOption | undefined>(undefined);
const appRatePlans = computed(() => {
  return store.getters["loanConfigurationModule/appRatePlans"];
});

const selectedDefaultRatePlan = computed(() => {
  return appRatePlans.value?.length === 1 ? appRatePlans.value[0] : undefined;
});

const selectedRatePlan = computed(() => store.state.loanConfigurationModule.selectedRatePlan);

const selectedRepaymentTerm = computed(() => {
  if (selectedRatePlan.value) {
    return selectedRatePlan.value;
  }
  return undefined;
});

const repaymentTermOption = computed<RepaymentTermOption | undefined>(() => {
  return repaymentTermOptions.value.find(
    (o: RepaymentTermOption) => o.repaymentTermId === selectedRepaymentTermId.value,
  );
});

const isValidRepaymentTerm = computed<boolean>(() => {
	return repaymentTermOption.value !== undefined;
});

const repaymentTerms = computed(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration.repaymentTermOptions,
);

const variableRateRepaymentTermOptions = computed<RepaymentTermOption[]>(
  () =>
    store.state.loanConfigurationModule.loanOptionsConfiguration.variableRateRepaymentTermOptions,
);
const fixedRateRepaymentTermOptions = computed<RepaymentTermOption[]>(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration.fixedRateRepaymentTermOptions,
);

const repaymentTermOptions = computed<RepaymentTermOption[]>(() => {
  if (props.selectedRateTypeId === RateTypeIds.FIXED) {
    return fixedRateRepaymentTermOptions.value;
  }

  if (props.selectedRateTypeId === RateTypeIds.VARIABLE) {
    return variableRateRepaymentTermOptions.value;
  }

  return [];
});

function selectUpdatedRepaymentTermOption(repaymentTermId: number) {
  const repaymentTermOption = repaymentTermOptions.value.find(
    (o: RepaymentTermOption) => o.repaymentTermId === repaymentTermId,
  );

  if (repaymentTermOption) {
    selectRepaymentTerm(repaymentTermId, repaymentTermOption);

    return;
  }
  selectedRepaymentTermId.value = 0;
  selectedRepaymentTermOption.value = undefined;
}
function selectRepaymentTerm(repaymentTermId: number, repaymentTermOption: RepaymentTermOption) {
  selectedRepaymentTermId.value = repaymentTermId;
  selectedRepaymentTermOption.value = repaymentTermOption;
  // if (ratePlan) {
  //   store.dispatch("loanConfigurationModule/setSelectedRatePlan", ratePlan);
  // }
}

function selectDefaultRatePlan() {
  // if only one rate plan for this term select it
  if (selectedDefaultRatePlan.value) {
    store.dispatch("loanConfigurationModule/setSelectedRatePlan", selectedDefaultRatePlan.value);
  }
}

function isActive(repaymentTermId: number) {
  return selectedRepaymentTermId.value === repaymentTermId;
}

function resetSelectedRepaymentTerm() {
  selectedRepaymentTermId.value = 0;
  store.dispatch("loanConfigurationModule/setSelectedRatePlan", null);
}

__expose({
  appRatePlans,
  isActive,
	isValidRepaymentTerm,
  repaymentTerms,
	repaymentTermOption,
  repaymentTermOptions,
  resetSelectedRepaymentTerm,
  selectedRatePlan,
  selectedRepaymentTerm,
  selectedRepaymentTermId,
  selectedRepaymentTermOption,
  selectUpdatedRepaymentTermOption,
  selectRepaymentTerm,
  selectDefaultRatePlan,
  selectedDefaultRatePlan,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "title" }, "What repayment term works best for you?", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "description" }, " We offer a variety of different repayment terms. Shorter repayment terms will generally have lower interest rates but the highest monthly payment. Longer repayment terms are likely to have the smallest monthly payment but a higher overall interest rate ", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repaymentTermOptions.value, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: option.repaymentTermId,
          class: _normalizeClass(["repayment-option-button repayment-term-button", [{ active: option?.repaymentTermId === selectedRepaymentTermId.value }]]),
          onClick: ($event: any) => (selectRepaymentTerm(option.repaymentTermId, option))
        }, [
          _createElementVNode("h5", null, _toDisplayString(`${option.repaymentTerm}`), 1),
          _createElementVNode("p", null, _toDisplayString(`${option.repaymentTerm}`) + " Estimated Rate Ranges:", 1),
          _createElementVNode("p", null, _toDisplayString(option?.estimatedRateRanges), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})